import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import AnalyticsConsent from './components/AnalyticsConsent';
import SiteFooter from './components/SiteFooter';
import styles from './App.module.css';
import { AuthProvider } from './context/AuthContext';

const HomePage = lazy(() => import('./pages/HomePage'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const CredoPage = lazy(() => import('./pages/CredoPage'));
const JoinFamilyPage = lazy(() => import('./pages/JoinFamilyPage'));
const LocalesPage = lazy(() => import('./pages/LocalesPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ShippingPage = lazy(() => import('./pages/ShippingPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const ITPage = lazy(() => import('./pages/ITPage'));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className={styles.App}>
          <Navbar />
          <AnalyticsConsent />

          <Suspense fallback={<main className={styles['route-loading']} aria-live="polite">Cargando...</main>}>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/productos" element={<ProductsPage />} />
            <Route path="/producto/:id" element={<ProductDetailPage />} />

            {/* Rutas de las páginas institucionales */}
            <Route path="/envios" element={<ShippingPage />} />
            <Route path="/locales" element={<LocalesPage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/credo" element={<CredoPage />} />
            <Route path="/familia" element={<JoinFamilyPage />} />

            {/* Rutas de Administración */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />

            {/* Checkout */}
            <Route path="/checkout" element={<CheckoutPage />} />

            {/* IT Diagnostics (Hidden) */}
            <Route path="/it-diagnostics" element={<ITPage />} />
            </Routes>
          </Suspense>
          <SiteFooter />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
